"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DDPContext = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const DDPConnector_1 = __importDefault(require("./DDPConnector"));
exports.DDPContext = react_1.default.createContext();
class DDPProvider extends react_1.default.Component {
    constructor(props, context) {
        super(props, context);
        this.ddpConnector = props.ddpConnector;
    }
    render() {
        const { children, ddpConnector } = this.props;
        return (react_1.default.createElement(exports.DDPContext.Provider, { value: ddpConnector }, children));
    }
}
DDPProvider.propTypes = {
    children: prop_types_1.default.node.isRequired,
    ddpConnector: prop_types_1.default.instanceOf(DDPConnector_1.default).isRequired,
};
DDPProvider.displayName = 'DDPProvider';
exports.default = DDPProvider;
//# sourceMappingURL=DDPProvider.js.map